import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { commonUtils } from '../../common/index.js';

import { BaseTransform } from './BaseTransform.js';

export class AggregateTransform extends BaseTransform {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions): void {
		let response: any = queryResponse;
		const { aggregateTransformOptions } = this.options;
		if (queryResponse && commonUtils.isArrayLike(queryResponse)) {
			const { type = 'sum', key } = aggregateTransformOptions;
			const values = key ? queryResponse.map((i) => i[key]) : queryResponse;
			const total = values.reduce((acc, value) => {
				return acc + value;
			}, 0);
			const count = values.length;
			if (type === 'sum') {
				response = total;
			}
			if (type === 'count') {
				response = count;
			}
			if (type === 'average') {
				response = count > 0 ? total / count : 0;
			}
		}
		return response;
	}
}
